/**
 * @name 충전금액입력
 * @description
 */
import {useEffect} from 'react'
import {Events, debug, useRoutes} from 'lib'
import styled from 'styled-components'
import {App} from 'template'
import {MENU} from 'config'
// contents
import Title from './contents/title'
import KeyPad from './contents/key-pad'
import {NextButton} from 'pages/common/components'
import {useAppSelector} from 'model'
import {COLOR} from 'styles'
import {CONTEXT_EVENT} from 'model/modules'

export default function Index() {
  // hooks
  const {navigate} = useRoutes()
  const {chargePrice} = useAppSelector(state => state.context)
  //*--------------------------------------------------*
  const isValidate = () => {
    return Number(chargePrice) >= 480 ? true : false
  }
  useEffect(() => {}, [])
  // hooks
  //*--------------------------------------------------*
  return (
    <App gnb={{prev: true, title: '충전 금액 입력', home: true}}>
      <Content>
        {/* 타이틀 */}
        <Title />
        {/* 키패드 */}
        <KeyPad />
        {/* 확인 */}
        <NextButton
          className={'auto'}
          bgcolor={isValidate() ? COLOR.blue30 : COLOR.gs40}
          style={{width: 830, marginTop: 156}}
          label="확인"
          onClick={() => {
            if (isValidate()) {
              navigate(MENU.CHARGE_START)
            } else {
              Events.emit(CONTEXT_EVENT.TOAST, '최소 입력 금액은 480원 입니다.')
            }
          }}
        />
      </Content>
    </App>
  )
}
//*--------------------------------------------------*
const Content = styled.div`
  width: 830px;
  margin: 0 auto;
`
